// Marker congestion level thresholds for the whole map
const CongestionLevelThresholds = [0, 250, 1000]

export default class ClustererCongestionCalculator {

    constructor(markersSize) {
        this.markersSize = markersSize;
        this.congestionLevel = this.getCongestionLevel();
        this.maxZoom = this.getMaxZoom();
        this.minimumClusterSize = this.getMinimumClusterSize();
    }

    getCongestionLevel() {
        if (this.markersSize >= CongestionLevelThresholds[2]) {
            return 'max'
        } else if (this.markersSize >= CongestionLevelThresholds[1]) {
            return 'mid'
        } else if (this.markersSize >= CongestionLevelThresholds[0]) {
            return 'min'
        }
    }

    getMaxZoom() {
        switch (this.congestionLevel) {
            case 'max':
                return 11;
            case 'mid':
                return 9;
            case 'min':
                return 8;
            default:
                return 8;
        }
    }

    getMinimumClusterSize() {
        switch (this.congestionLevel) {
            case 'max':
                return 5;
            case 'mid':
                return 3;
            case 'min':
                return 2;
            default:
                return 2;
        }
    }

}